import { IGenericObject, GenericObject } from "../common";
import { BaseModel } from "../base-model";
import { IKeuringsPlatformInfoModel, KeuringsPlatformInfoModel } from "./property-keuring-platform.model";

export interface IMijnverhuisInfoResponseModel {
  CategoryTypeId?: number;
  PropertyPurposeId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyCountryId?: number;
  PropertySiteId?: number;
  CategoryTypes?: IGenericObject[];
  Nationalities?: IGenericObject[];
  Purposes?: IGenericObject[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
  LeavingCustomers?: IKeuringsPlatformInfoModel[];
}

export class MijnverhuisInfoResponseModel extends BaseModel<IMijnverhuisInfoResponseModel> implements IMijnverhuisInfoResponseModel {
  CategoryTypeId?: number;
  PropertyPurposeId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyCountryId?: number;
  PropertySiteId?: number;
  CategoryTypes?: IGenericObject[];
  Nationalities?: IGenericObject[];
  Purposes?: IGenericObject[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
  LeavingCustomers?: IKeuringsPlatformInfoModel[];
  constructor(option?: IMijnverhuisInfoResponseModel) {
    super(option);
    this.CategoryTypeId = option.CategoryTypeId;
    this.PropertyPurposeId = option.PropertyPurposeId;
    this.PropertyAddress = option.PropertyAddress;
    this.PropertyHouseNumber = option.PropertyHouseNumber;
    this.PropertyPostCode = option.PropertyPostCode;
    this.PropertyCityName = option.PropertyCityName;
    this.PropertySiteId = option.PropertySiteId;
    this.PropertyCountryId = option.PropertyCountryId;
    this.CategoryTypes = option.CategoryTypes || [];
    this.Nationalities = option.Nationalities || [];
    this.Purposes = option.Purposes || [];
    this.ContactInfos = option.ContactInfos || [];
    this.LeavingCustomers = option.LeavingCustomers || [];
  }
}

export interface IMijnVerhuisRequestModel {
  PropertyId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyPurposeId?: number;
  PropertyCountryId?: number;
  PropertySiteId?: number;
  PropertyCountryName?: string;
  CategoryType?: IGenericObject;
  Transaction?: IGenericObject;
  PropertyCountry?: IGenericObject;
  PrimaryContact?: IKeuringsPlatformInfoModel;
  SecondaryContact?: IKeuringsPlatformInfoModel;
  LeavingCustomer?: IKeuringsPlatformInfoModel;
  Connection?: IMijnverhuisConnectionModel;
}

export class MijnVerhuisRequestModel extends BaseModel<IMijnVerhuisRequestModel> implements IMijnVerhuisRequestModel {
  PropertyId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyPurposeId?: number;
  PropertyCountryId?: number;
  PropertySiteId?: number;
  PropertyCountryName?: string;
  CategoryType?: IGenericObject;
  Transaction?: IGenericObject;
  PropertyCountry?: IGenericObject;
  PrimaryContact?: IKeuringsPlatformInfoModel;
  SecondaryContact?: IKeuringsPlatformInfoModel;
  LeavingCustomer?: IKeuringsPlatformInfoModel;
  Connection?: IMijnverhuisConnectionModel;
  constructor(option?: IMijnVerhuisRequestModel) {
    super(option);
    this.PropertyId = option.PropertyId || null;
    this.PropertyAddress = option.PropertyAddress || null;
    this.PropertyHouseNumber = option.PropertyHouseNumber || null;
    this.PropertyPostCode = option.PropertyPostCode || null;
    this.PropertyCityName = option.PropertyPostCode || null;
    this.PropertyPurposeId = option.PropertyPurposeId || null;
    this.PropertyCountryId = option.PropertyCountryId || null;
    this.PropertySiteId = option.PropertySiteId || null;
    this.PropertyCountryName = option.PropertyCountryName || null;
    this.CategoryType = option.CategoryType || new GenericObject();
    this.Transaction = option.Transaction || new GenericObject();
    this.PropertyCountry = option.PropertyCountry || new GenericObject();
    this.PrimaryContact = option.PrimaryContact || new KeuringsPlatformInfoModel({});
    this.SecondaryContact = option.SecondaryContact || new KeuringsPlatformInfoModel({});
    this.LeavingCustomer = option.LeavingCustomer || new KeuringsPlatformInfoModel({});
    this.Connection = option.Connection || new MijnverhuisConnectionModel({});
  }
}

export interface IMijnverhuisConnectionModel {
  IsEnergy?: boolean;
  IsTelecom?: boolean;
  IsWater?: boolean;
  EnergySupplier?: string;
  TelecomSupplier?: string;
  EnergyProduct?: string;
  TelecomProduct?: string;
  Availability?: string;
  LocationRemark?: string;
  Remark?: string;
  AgencyStaffName?: string;
  AgencyStaffEmail?: string;
}

export class MijnverhuisConnectionModel extends BaseModel<IMijnverhuisConnectionModel> implements IMijnverhuisConnectionModel { 
  IsEnergy?: boolean;
  IsTelecom?: boolean;
  IsWater?: boolean;
  EnergySupplier?: string;
  TelecomSupplier?: string;
  EnergyProduct?: string;
  TelecomProduct?: string;
  Availability?: string;
  LocationRemark?: string;
  Remark?: string;
  AgencyStaffName?: string;
  AgencyStaffEmail?: string;
  constructor(option?: IMijnverhuisConnectionModel) {
    super(option);
    this.IsEnergy = option.IsEnergy || false;
    this.IsTelecom = option.IsTelecom || false;
    this.IsWater = option.IsWater || false;
    this.EnergySupplier = option.EnergySupplier || null;
    this.TelecomSupplier = option.TelecomSupplier || null;
    this.EnergyProduct = option.EnergyProduct || null;
    this.TelecomProduct = option.TelecomProduct || null;
    this.Availability = option.Availability || null;
    this.LocationRemark = option.LocationRemark || null;
    this.Remark = option.Remark || null;
    this.AgencyStaffName = option.AgencyStaffName || null;
    this.AgencyStaffEmail = option.AgencyStaffName || null;
  }
}